export default "__VITE_ASSET__DccL_YsB__"